import { render, staticRenderFns } from "./AdminDataQueriesList.vue?vue&type=template&id=00afbcd0&scoped=true&"
import script from "./AdminDataQueriesList.vue?vue&type=script&lang=js&"
export * from "./AdminDataQueriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00afbcd0",
  null
  
)

export default component.exports